<template>
  <div class="common_wrap bg_grey color_black relative">
    <!-- 活动规则按钮 -->
    <div v-if="isRuleShow" class="rule" @click="activityRuleClick">规则说明</div> 
    <!-- 新用户活动-新课礼包+促投礼包  新用户活动/签到活动 & 3日促投 样式相同 -->
    <div v-if="(activityType == 3 || activityType == 18 || activityType == 19) && [1,2,3].includes(promoteType)" class="promotion" :style="{ backgroundImage: `url(${activityInfo.image})` }">
      <div class="giftList">
        <img src="//assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/20231001_09.png" alt="" class="title" />
        <div class="giftItem" v-for="(item, index) in threeRewardVos" :key="index">
          <img :src="item.giftIcon" alt="" class="giftItemImg">
          <div class="giftItemContent">
            <p class="giftName">{{ item.giftName }}</p>
            <p class="giftCondition van-multi-ellipsis--l2">{{ item.drawTask }}</p>
            <p class="giftContent van-multi-ellipsis--l2">{{ item.giftContent }}</p>
          </div>
          <button v-if="item.drawStatus == 0 || item.drawStatus == 2" @click="receive({...item, isPromote: true }, true)" class="giftBtn">领取</button>
          <button v-if="item.drawStatus == 1" @click="receive({...item, isPromote: true }, true)" class="gray giftBtn">已领取</button>
        </div>
      </div>
      <div v-if="activityInfo.activityType == 0" class="giftExtraBack">
        <!-- <img :src="activityInfo.image" alt="" class="title"> -->
      </div>
      <div v-if="activityInfo.activityType == 1" class="signAct1">
        <img src="//assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/20231001_10.png" alt="" class="title">
        <div v-for="(item, index) in activityInfo.signInRewardVos" :key="index">
          <div class="giftItem">
            <img :src="item.giftIcon" alt="" class="giftItemImg">
            <div class="giftItemContent">
              <p class="giftName" >{{ item.giftName }}</p>
              <p class="giftContent" >{{ item.giftContent }}</p>
            </div>
            <button v-if="item.drawStatus == 0" @click="receive(item)">领取</button>
            <button v-if="item.drawStatus == 1" @click="receive(item)" class="gray">已领取</button>
            <button v-if="item.drawStatus == 2" class="gray">第{{ item.drawCondition }}日可领</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 新用户活动-新课礼包 / 新用户活动-新课礼包+促投礼包  签到活动 样式相同 -->
    <div v-else-if="(activityType == 3 || activityType == 18 || activityType == 19) && activityInfo.activityType == 1" class="signAct" :style="{ backgroundImage: `url(${activityInfo.image})` }">
      <img src="https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/jml.png" alt="" class="title">
      <div class="giftList" v-if="activityInfo.signInRewardVos && activityInfo.signInRewardVos.length">
        <div v-if="!hasExtraGift" class="giftNormal">
          <div v-for="(item, index) in activityInfo.signInRewardVos" :key="index">
            <div :class="['giftItem', index % 2 === 0 ? 'giftItemLeft' : 'giftItemRight']">
              <img :src="item.giftIcon" alt="" class="giftItemImg">
              <div class="giftItemContent">
                <p class="giftName" >{{ item.giftName }}</p>
                <p class="giftContent" >{{ item.giftContent }}</p>
                <button v-if="item.drawStatus == 0" @click="receive(item)">领取</button>
                <button v-if="item.drawStatus == 1" @click="receive(item)" class="gray">已领取</button>
                <button v-if="item.drawStatus == 2" class="gray">仅{{ item.drawCondition }}日领取</button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="giftSpecial">
          <div v-for="(item, index) in normalGift" :key="index">
            <div class="giftItem">
              <p class="giftName" >{{ item.giftName }}</p>
              <img :src="item.giftIcon" alt="" class="giftItemImg">
              <p class="giftContent" >{{ item.giftContent }}</p>
              <button v-if="item.drawStatus == 0" @click="receive(item)">领取</button>
              <button v-if="item.drawStatus == 1" @click="receive(item)" class="gray">已领取</button>
              <button v-if="item.drawStatus == 2" class="gray">仅{{ item.drawCondition }}日领取</button>
            </div>
          </div>
        </div>
        <div class="extraGiftItem" v-if="extraGift">
          <img :src="extraGift.giftIcon" alt="" class="giftItemImg">
          <div class="giftItemContent">
            <p class="giftName" >{{ extraGift.giftName }}</p>
            <p class="giftContent" >{{ extraGift.giftContent }}</p>
          </div>
          <button v-if="extraGift.drawStatus == 0" @click="receive(extraGift, true)">领取</button>
          <button v-if="extraGift.drawStatus == 1" @click="receive(extraGift, true)" class="gray">已领取</button>
        </div>
      </div>
    </div>
    <!-- 其余统一样式 -->
    <div v-else-if="activityType">
      <!-- // registerType 1app注册 2小游戏注册 -->
      <!-- 非小游戏注册展示用户名，其他不展示 -->
      <div v-if="activityInfo.registerType === 1" class="userName">
        用户名：{{ activityInfo.syUsername }}
      </div>

      <!-- 活动页面 -->
      <div class="page" :style="{ backgroundImage: `url(${activityInfo.image})` }"></div>

      <!-- 参与按钮 -->
      <div class="participatingButton" :style="{ background: isCanParticipation ? '#fe732e' : '#8c8a8c' }" @click="participatingActivity">
        参与
      </div>
    </div>

    <Popup
      :visible.sync="visible"
      v-bind="feedback"
      :skins="{
        headerBg: (activityType == 3 || activityType == 18 || activityType == 19) && activityInfo.activityType == 1 && ![1,2,3].includes(promoteType) ? '#860E00' : '#fe732e' 
      }"
      @confirm="feedback.onSure"
    >
      <template v-if="feedbackType === 'Success'">
        <div class="flex_center">
          <div class="giftContent">
            您的专属奖励码：
            <span class="giftCode">
              {{ gitCode }}
            </span>
          </div>
        </div>
        <div v-clipboard="gitCode" class="copyBtn">
          复制
        </div>
      </template>
      <template v-if="feedbackType === 'Fail'">
        <div class="flex_center">
          <img style="width: 0.66rem; height: 0.66rem;" :src="curGift.giftIcon" alt="">
          <div class="text_left ml_6">
            <div class="fs_14 mb_4 bold giftName">{{ curGift.giftName }}</div>
            <div class="fs_12" style="line-height: 0.1867rem; width: fit-content;">{{ curGift.giftContent }} </div>
          </div>
        </div>
      </template>
      <template v-if="feedbackType === 'NotFoundUser'">
        <div>
          <p class="fs_15" style="line-height: 1.25;">请点击一下首条消息底部的见面惊喜，再参与此活动。</p>
          <p class="fs_15" style="line-height: 1.25;">如果您未找到见面惊喜，可【点我头像-联系客服】进行人工咨询</p>
          <img style="width: 100%" src="https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/1303-guide.jpeg" alt="">
        </div>
      </template>
      <template v-if="feedbackType === 'AlreadyBinded'">
        <div>
          <p class="fs_15" style="line-height: 1.25;">一份见面礼仅限一个微信领取，请您用首次点击该见面礼的微信账号进行领取。</p>
          <p class="fs_15" style="line-height: 1.25;">如您有其他疑问，请【点我头像-人工客服】进行咨询</p>
        </div>
      </template>
    </Popup>

    <!-- 规则说明弹窗 -->
    <Popup
      :visible.sync="ruleShow"
      v-bind="ruleFeedback"
      :skins="{
        headerBg: '#860E00' 
      }"
    >
      <template>
        <div class="ruleContent">{{ ruleContent }}</div>
      </template>
    </Popup>
  </div>
</template>

<script>
import Popup from '@/components/Popup.vue';
import { drawActivityReward, getActivityDetail, bandUserOpenid, drawSignReward, getActivityRule, drawPromoteGift } from '@/apis/qiweiMiniGame'
import trackingMixin, { EVENT_TYPE_ENUM } from "@/mixins/tracking"; 
import store from "@/store";
import { storeGet } from "@/utils/localStore"
import { Toast } from 'vant'

export default {
  components: {
    Popup
  },
  mixins: [trackingMixin],
  data () {
    return {
      isLoading: false,
      disabledPull: false,
      hasFetched: false,
      visible: false,

      activity_id: '',
      // registerType 1app注册 2小游戏注册
      activityInfo: {},
      gitCode: '', // 用户满足资格时可领取的礼包码
      activityType: '', // 活动类型 3新用户活动 5降登复登维护  6降充复充维护  9流失召回
      sceneEnum: {
        3: 1,
        5: 2,
        6: 3,
        9: 4,
        14: 14,
        18: 1,
        19: 1
      }, // 使用场景 1新用户活动  2降登复登维护  3降充复充维护  4流失召回
      ruleSceneEnum: {
        5: 1,
        6: 2,
        9: 3,
        14: 4,
      }, // 规则使用场景，1降登复登  2降充复充  3流失召回  4促投维护
      uid: '', // 新用户活动 只有活动链接里边的type=3时才会有这个字段值，并且需要绑定用户的openid
      appkey: '',
      sceneType: '', // 活动类型 14 时候存在，接口需要，
      promoteType: '', // 促投类型：0-单日；1-3日 (仅新客、新客+促投返回 其它为空)
      threeRewardVos: [],
      hasExtraGift: false,
      extraGift: undefined,
      normalGift: [],
      isExtraGift: false,
      ruleBtnShow: false, // 规则按钮是否展示
      ruleContent: '', // 规则内容
      ruleShow: false, // 规则弹窗是否展示
      feedbackType: 'Success', // 反馈类型
      curGift: {}, // 记录当前礼包
    }
  },
  computed: {
    // openID和wxappid
    wechatInfo () {
      return {
        openid: store.getters['user/openid'],
        wxappid: storeGet('WX_APP_ID')
        // wxappid: 'wx5e3815b7f3f113b5'
      }
    },
    isCanParticipation () {
      if (this.activityType == 14) {
        return true;
      }
      const { drawStatus = 0, activityStatus } = this.activityInfo
      // 活动已结束的话按钮置灰
      if (activityStatus === 1) return false
      return drawStatus === 0 ? false : true
    },
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    feedbackMap () {
      const { drawTask } = this.curGift
      return {
        Success: {
          title: this.isExtraGift ? '恭喜获得惊喜': '恭喜获得奖励',
          message: [],
          showConfirmButton: false,
          onSure: () => {},
          onCancel: () => {}
        },
        Fail: {
          title: drawTask,
          innerTitle: '完成领取任务即可获得',
          confirmButtonText: '我已知晓',
          onSure: () => {
            this.triggerVisible(false)
          },
        },
        NotFoundUser: {
          title: '提示',
          showConfirmButton: false,
          onSure: () => {
            this.triggerVisible(false)
          },
        },
        AlreadyBinded: {
          title: '提示',
          showConfirmButton: false,
          onSure: () => {
            this.triggerVisible(false)
          },
        },
      }
    },
    ruleFeedback () {
      return {
        title: '活动规则',
        message: [],
        showConfirmButton: false,
        onSure: () => {},
        onCancel: () => {}
      }
    },
    isRuleShow () {
      return [5, 6, 9, 14, '5', '6', '9', '14'].includes(this.activityType) && this.ruleBtnShow;
    },
    shouldShowDialog () {
      const { type, activityType, promoteType } = this.activityInfo || {}
      // 新用户 3日促投活动
      return type === 3 && [0, 1].includes(activityType) && promoteType === 1
    },
  },
  created () {
    document.title = '加载中'
  },
  async mounted () {
    const params = JSON.parse(localStorage.getItem('wxAuthQuery'))
    const { type, activityId, uid = '', appkey, sceneType } = this.$route.query
    this.activityType = type || params.type
    this.activity_id = activityId || params.activityId
    this.uid = uid || params.uid
    this.appkey = appkey || params.appkey
    this.sceneType = sceneType || params.sceneType
    // 新用户的时候需要绑定openid
    if (this.activityType == 3) {
      await this.wechatBindUserOpenId()
    }
    this.init()
  },
  methods: {
    // 企微活动规则
    async getActivityRule() {
      const res = await getActivityRule({});
      if (res.data) {
        const ruleItem = res.data[this.ruleSceneEnum[this.activityType]];
        if (!ruleItem) return;
        this.ruleContent = ruleItem.rule_content;
        this.ruleBtnShow = ruleItem.display == 1;
      }
    },
    // 企微活动规则点击
    activityRuleClick() {
      this.ruleShow = true;
    },
    // 绑定用户openid
    async wechatBindUserOpenId () {
      const params = {
        ...this.wechatInfo,
        activityId: this.activity_id,
        uid: this.uid,
        appkey: this.appkey
      }
      // 如果是null 或者 undefined 的时候, 签名哪里会把这个字段计算进去，但是请求的时候会被过滤掉，后端计算的时候没有这个字段会导致签名失败
      if (![undefined, null].includes(this.sceneType)) {
        params.sceneType = this.sceneType
      }
      await bandUserOpenid(params)
    },
    init () {
      this.getActivityDetailInfo()
      this.getActivityRule()
    },

    async receive(item, isEtra = false) {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.enterprise_wx_h5_page_draw_button,
        {
          activity_id: this.activity_id,
          scene: this.sceneEnum[this.activityType],
          userId: this.activityInfo.uid,
          username: this.activityInfo.syUsername,
          activity_type: (this.activityType == 3 || this.activityType == 18 || this.activityType == 19) && this.activityInfo.activityType == 1 ? 1 : undefined,
          days: item.drawCondition || undefined,
          pay_money: item.accumulativeMoney || undefined,
          promote_type: this.promoteType
        },
        {}
      )
      this.curGift = item
      this.isExtraGift = isEtra;
      if (item.drawStatus == 1) {
        this.gitCode = item.cdk
        if (!item.cdk) {
          this.$toast('领取失败，请联系客服')
        } else {
          this.triggerVisible(true)
        }
        return
      }
      const api = item.isPromote ? drawPromoteGift : drawSignReward
      try {
        const r = await api({
          uid: this.activityInfo.uid,
          activityId: this.activity_id,
          slaveId: item.slaveId,
          sceneType: this.activityInfo.sceneType
        })
        this.gitCode = r.data.cdk
        if (!r.data.cdk) {
          this.$toast('领取失败，请联系客服')
        } else {
          this.triggerVisible(true)
        }
        // 重新获取一下当前用户在当前活动的状态
        this.getActivityDetailInfo(false)
        // 领取奖励埋点上报
        this.EVENT_TRACKING(
          EVENT_TYPE_ENUM.enterprise_wx_h5_page_receive_award,
          {
            activity_id: this.activity_id,
            scene: this.sceneEnum[this.activityType],
            cdk: r.data.cdk,
            userId: this.activityInfo.uid,
            username: this.activityInfo.syUsername,
            activity_type: 1,
            days: isEtra ? undefined : item.drawCondition,
            pay_money: isEtra ? item.accumulativeMoney: undefined,
            promote_type: this.promoteType
          },
          {}
        )
      } catch (error) {
        const { code, msg } = error
        if (code === 1313 && this.shouldShowDialog) {
          this.EVENT_TRACKING(
            EVENT_TYPE_ENUM.enterprise_wx_h5_dissatisfy_draw_pop,
            {
              activity_id: this.activity_id,
              scene: 1,
              activity_type: this.activityInfo.activityType,
              pay_money: item.accumulativeMoney,
              promote_type: this.promoteType,
              draw_condition: item.drawCondition,
              appkey: this.appkey,
            }
          )
          this.triggerVisible(true, 'Fail')
        } else {
          this.$toast(msg)
        }
      }
    },
    //  获取活动数据信息
    getActivityDetailInfo (isTrack = true) {
      const params = {
        activityId: this.activity_id,
        ...this.wechatInfo,
        type: this.activityType,
        appkey: this.appkey,
      }
      // 如果是null 或者 undefined 的时候, 签名哪里会把这个字段计算进去，但是请求的时候会被过滤掉，后端计算的时候没有这个字段会导致签名失败
      if (![undefined, null].includes(this.sceneType)) {
        params.sceneType = this.sceneType
      }
      return getActivityDetail(params).then(res => {
        this.activityInfo = res.data
        this.sceneType = res.data.sceneType
        this.promoteType = res.data.promoteType
        this.threeRewardVos = res.data.threeRewardVos
        // document.title = res.data.name
        document.title = '活动'
        if (res.data.signInRewardVos && res.data.signInRewardVos.length) {
          this.hasExtraGift = res.data.signInRewardVos.some(item => item.extraType === 1);
          this.extraGift = res.data.signInRewardVos.find(item => item.extraType === 1);
          this.normalGift = res.data.signInRewardVos.filter(item => item.extraType !== 1);
          console.log(this.extraGift, this.normalGift)
        }

        // isTrack 是否要上报和进页面提示 
        // 如果是用户第一次进来页面初始化的时候需要提示并上报数据
        if (isTrack) {
          if (res.data.activityStatus === 1) {
            this.$toast(`活动已结束`)
          }
  
          // 埋点上报
          const track_name = res.data.activityStatus === 1 ? EVENT_TYPE_ENUM.enterprise_wx_h5_page_end : EVENT_TYPE_ENUM.enterprise_wx_h5_page_underway
          this.EVENT_TRACKING(
            track_name,
            {
              activity_id: this.activity_id,
              scene: this.sceneEnum[this.activityType],
              button_status: res.data.activityStatus === 1 ? undefined : (this.isCanParticipation ? 2 : 1),
              userId: res.data.uid,
              username: res.data.syUsername,
              activity_type: (this.activityType == 3 || this.activityType == 18 || this.activityType == 19) && res.data.activityType == 1 ? 1 : undefined,
              promote_type: res.data.promoteType
            },
            {}
          )
        }
      }).catch((error) => {
        const { code } = error
        if (code === 1306) {
          this.triggerVisible(true, 'NotFoundUser')
        }
        if (code === 1319) {
          this.triggerVisible(true, 'AlreadyBinded')
        }
      })
    },
    // 参与活动领取礼包码
    participatingActivity () {
      if (this.activityType == 14) {
        this.EVENT_TRACKING(
          EVENT_TYPE_ENUM.enterprise_wx_h5_page_receive_award,
          {
            activity_id: this.activity_id,
            scene: this.sceneEnum[this.activityType],
            userId: this.activityInfo.uid,
            username: this.activityInfo.syUsername,
            promote_type: this.promoteType
          },
          {}
        )
        window.open('https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzk0MzI1NDQzNA==&scene=117#wechat_redirect')
        return;
      }

      const { drawStatus, cdk = '', activityStatus } = this.activityInfo


      // 活动已结束的时候直接提示活动已结束
      if (activityStatus === 1) {
        return this.$toast(`活动已结束`)
      }

      // 不满足领取条件
      if (drawStatus === 0) {
        return Toast({
          message: `${this.activityInfo.msg}`,
          className: 'toastCustomClass'
        })
      }
      // 满足领取条件，但是已经领取过了
      if (drawStatus === 2) {
        this.gitCode = cdk
        this.triggerVisible(true)
        return
      }
      // 没有活动信息
      if (!this.activityInfo.activityId) return

      const params = {
        ...this.wechatInfo,
        activityId: this.activity_id,
        type: this.activityType,
        appkey: this.appkey,
      }
      drawActivityReward(params).then(res => {
        this.gitCode = res.data.cdk
        this.triggerVisible(true)
        // 重新获取一下当前用户在当前活动的状态
        this.getActivityDetailInfo(false)
        // 领取奖励埋点上报
        this.EVENT_TRACKING(
          EVENT_TYPE_ENUM.enterprise_wx_h5_page_receive_award,
          {
            activity_id: this.activity_id,
            scene: this.sceneEnum[this.activityType],
            cdk: res.data.cdk,
            userId: this.activityInfo.uid,
            username: this.activityInfo.syUsername,
            promote_type: this.promoteType
          },
          {}
        )
      }).catch(() => {})
    },
    triggerVisible (visible, type = 'Success') {
      this.visible = visible
      if (visible) {
        this.feedbackType = type
      }
    },
  }
}
</script>

<style lang="scss">
.toastCustomClass {
  word-break: unset !important;;
}
</style>
<style lang="scss" scoped>
.rule {
  position: fixed;
  top: 20px;
  right: 20px;
  color: #fff;
  z-index: 10;
  text-decoration: underline;
}
.ruleContent {
  width: 100%;
  max-height: 300px;
  min-height: 200px;
  overflow-y: scroll;
  line-height: 24px;
  white-space: pre-wrap;
}

.userName {
  width: 100%;
  position: absolute;
  top: 5%;
  left: 2%;
  color: #fff;
  font-size: 17px;
  z-index: 99;
}
.page {
  width: 100%;
  min-height: 100vh;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  // background-color: #000;
  background-position: center;
}

.participatingButton {
  width: 151px;
  height: 36.5px;
  background: #fe732e;
  border-radius: 18.5px;
  color: #fff;
  font-size: 17px;
  text-align: center;
  line-height: 36.5px;
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
}
.giftContent {
  font-size: 17px;
  font-family: Source Han Sans CN, Source Han Sans CN-Medium;
  font-weight: 500;
  color: #000;
}
.giftCode {
  color: #ff1b1b;
}
.copyBtn {
  display: inline-block;
  width: 110px;
  height: 35px;
  background: #ff1b1b;
  border-radius: 5.5px;
  font-size: 17px;
  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  line-height: 35px;
  margin: 30px auto 0;
  display: flex;
  justify-content: center;
}

.promotion {
  width: 100%;
  min-height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-top: 155px;
  padding-bottom: 20px;
  .giftList {
    width: 342px;
    min-height: 282px;
    margin: 0 auto;
    background: url('//assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/20231001_18.png') no-repeat 100% 100%;
    border-radius: 12px;
    box-sizing: border-box;
    padding: 10px 6px;
    .title {
      width: 250px;
      display: block;
      margin: 0 auto 10px;
    }
    .giftItem {
      width: 330px;
      min-height: 63px;
      padding: 7px 10px;
      background: #FFFFFF;
      border-radius: 12px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }
      .giftItemImg {
        width: 50px;
        height: 50px;
        margin-right: 10px;
      }
      .giftItemContent {
        width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        > p {
          margin: 0;
        }
        .giftName {
          font-size: 13px;
          color: #272828;
          margin-bottom: 6px;

          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          -webkit-line-clamp: 1;
          text-overflow: ellipsis;
        }
        .giftContent {
          font-size: 11px;
          line-height: 14px;
          color: #9FA0A0;
        }
        .giftCondition {
          font-size: 11px;
          line-height: 13px;
          color: #FB672F;
          margin-bottom: 4px;
        }
      } 
      .giftBtn {
        width: 70px;
        height: 30px;
        background: linear-gradient(270deg,#ff3165 0%, #ff8938 100%), #ff8a3d;
        border-radius: 15px;
        font-size: 12px;
        color: #FFFFFF;
        text-align: center;
        line-height: 30px;
        border: none;
        outline: none;
        &.gray {
          background: #9FA0A0;
        }
        &:active {
          opacity: 0.9;
        }
      }
    }
  }
  .giftExtraBack {
    width: 342.5px;
    height: 220px;
    margin: 0 auto;
    margin-top: 12px;
    > img {
      width: 100%;
      height: 100%;
    }
  }
  
  .signAct1 {
    width: 342.5px;
    height: 220px;
    margin: 10px auto;
    padding-top: 40px;
    box-sizing: border-box;
    background-image:  url('//assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/20231001_04.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    .title {
      position: absolute;
      top: 5px;
      left: 5px;
      width: 220px;
      display: block;
      margin-bottom: 10px;

    }
    .giftItem {
      width: 330px;
      height: 52px;
      background: #fffaf0;
      border-radius: 12px;
      margin: 0 auto 5px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      box-sizing: border-box;
      
      .giftItemImg {
        width: 38.5px;
        height: 38.5px;
        margin-right: 10px;
        flex-shrink: 0;
      }
      
      .giftItemContent {
        flex: 1;
        overflow: hidden;
        
        .giftName {
          font-size: 16px;
          color: #272828;
          font-weight: 500;
          margin: 0 0 6px 0;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          -webkit-line-clamp: 1;
          text-overflow: ellipsis;
        }
        
        .giftContent {
          font-size: 12px;
          color: #9FA0A0;
          margin: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      
      button {
        width: 70px;
        height: 30px;
        background: linear-gradient(270deg,#ff3165 0%, #ff8938 100%), #ff8a3d;
        border-radius: 15px;
        font-size: 12px;
        color: #FFFFFF;
        text-align: center;
        line-height: 30px;
        border: none;
        outline: none;
        &.gray {
          background: #9FA0A0;
        }
        &:active {
          opacity: 0.9;
        }
      }
    }
  }
}
.signAct {
  width: 100%;
  min-height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-top: 25px;
  padding-bottom: 20px;
  .title {
    width: 100%;
    margin-bottom: 10px;
  }
  .giftList {
    .giftNormal {
      .giftItem {
        width: 100%;
        height: 162px;
        display: flex;
        padding: 0 20px;
        background: url('https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/group3.png') no-repeat;
        background-size: 95% 100%;
        &.giftItemLeft {
          background: url('https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/group1.png') no-repeat;
          background-size: 95% 100%;
          background-position: right;
        }
        &.giftItemRight {
          flex-direction: row-reverse;
          .giftItemImg {
            margin-left: 0px;
            margin-right: 13px;
          }
        }
        .giftItemImg {
          width: 100px;
          height: 100px;
          margin-top: 37px;
          margin-left: 20px;
        }
        .giftItemContent {
          > p {
            text-align: center;
            color: #FFFFFF;
          }
          .giftName {
            margin-top: 54px;
            margin-bottom: 12px;
            font-weight: 700;
            font-size: 18px;
          }
          .giftContent {
            font-size: 11px;
            line-height: 16px;
            padding: 0 15px;
            font-weight: 400;
            margin-bottom: 10px;
            min-width: 230px;
            height: 30px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            -webkit-line-clamp: 2; /* 限制显示两行 */
            text-overflow: ellipsis;
          }
          > button {
            width: 110px;
            height: 28px;
            box-sizing: border-box;
            border: none;
            outline: none;
            background: url('https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/buttonBaseState1.png') no-repeat;
            background-size: 100% 100%;
            border-radius: 2px;
            font-size: 15px;
            font-weight: 700;
            display: block;
            margin: 0 auto;
            color: #280100;
            letter-spacing: 3px;
            &:active {
              // 高亮
              opacity: 0.9;
            }
            &.gray {
              background: url('https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/buttonBaseState2.png') no-repeat;
              background-size: 100% 100%;
              color: #FFFFFF;
              letter-spacing: 1px;
            }
          }
        }
      }
    }
    .giftSpecial {
      display: flex;
      justify-content: center;
      .giftItem {
        width: 115px;
        height: 171px;
        margin: 0 3px;
        flex: none;
        background: url('https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/labelBase.png') no-repeat;
        background-size: 100% 100%;
        color: #FFEE7E;
        text-align: center;
        padding-top: 13px;
        .giftName {
          font-size: 13px;
          margin-bottom: 10px;
        }
        .giftItemImg {
          width: 60px;
          height: 60px;
          display: block;
          margin: 0 auto;
        }
        .giftContent {
          height: 25px;
          margin-top: 3px;
          margin-bottom: 12px;
          color: #FFFFFF;
          padding: 0 10px;
          font-size: 9px;
          line-height: 14px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          -webkit-line-clamp: 2; /* 限制显示两行 */
          text-overflow: ellipsis;
        }
        > button {
          width: 70px;
          height: 20px;
          box-sizing: border-box;
          border: none;
          outline: none;
          background: url('https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/buttonBaseState1.png') no-repeat;
          background-size: 100% 100%;
          border-radius: 2px;
          font-size: 10px;
          font-weight: 700;
          display: block;
          margin: 0 auto;
          color: #280100;
          &:active {
            // 高亮
            opacity: 0.9;
          }
          &.gray {
            background: url('https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/buttonBaseState2.png') no-repeat;
            background-size: 100% 100%;
            color: #FFFFFF;
            letter-spacing: 1px;
          }
        }
      }
    }
    .extraGiftItem {
      position: relative;
      width: 375px;
      margin: auto;
      margin-top: -25px;
      background: url('https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/propBase.png') no-repeat;
      background-size: 100% auto;
      padding-top: 120px;
      .giftItemImg {
        width: 180px;
        display: block;
        margin: 0 auto;
      }
      .giftItemContent {
        background: url('https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/group2.png') no-repeat;
        background-size: 100% 100%;
        color: #FFE38E;
        width: 320px;
        height: 110px;
        padding-top: 13px;
        text-align: center;
        margin: auto;
        .giftName {
          font-size: 16.5px;
        }
        .giftContent {
          color: #FFE38E;
          margin-top: 22px;
          font-size: 12px;
          line-height: 18px;
          display: -webkit-box;
          padding: 0 40px;
          -webkit-box-orient: vertical;
          overflow: hidden;
          -webkit-line-clamp: 3; /* 限制显示两行 */
          text-overflow: ellipsis;
        }
      }
      > button {
        width: 182px;
        height: 43px;
        box-sizing: border-box;
        border: none;
        outline: none;
        background: url('https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/buttonBaseState1.png') no-repeat;
        background-size: 100% 100%;
        border-radius: 2px;
        font-size: 20px;
        font-weight: 700;
        display: block;
        margin: 20px auto;
        color: #280100;
        letter-spacing: 3px;
        &:active {
          // 高亮
          opacity: 0.9;
        }
        &.gray {
          background: url('https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/buttonBaseState2.png') no-repeat;
          background-size: 100% 100%;
          color: #FFFFFF;
          letter-spacing: 1px;
        }
      }
    }
  }
}
</style>
